import { TaskDueDateState } from "@jugl-web/domain-resources/tasks";
import { TaskDueDateFormPopover } from "@jugl-web/domain-resources/tasks/components/DueDatePickerPopover";
import { isTicketOverdue } from "@jugl-web/domain-resources/tickets/utils/isTicketOverdue";
import { TicketStatus } from "@jugl-web/rest-api/tickets";
import { cx } from "@jugl-web/utils";
import { useFormattedDate } from "@jugl-web/utils/hooks/useFormattedDate";
import { TicketPropertyPill } from "@jugl-web/domain-resources/tickets/components/TicketPropertyPill";
import { FC } from "react";
import {
  TicketDetailItem,
  TicketDetailItemPlaceholder,
} from "../TicketDetailItem";
import { ReactComponent as CalendarDueIcon } from "./assets/calendar-due.svg";
import { ReactComponent as CalendarIcon } from "./assets/calendar.svg";

interface DueToDetailItemProps {
  dueDate: Date | null;
  status: TicketStatus;
  onChange: (dueDate: Date | null) => void;
}

export const DueToDetailItem: FC<DueToDetailItemProps> = ({
  dueDate,
  status,
  onChange,
}) => {
  const { formatDateTimeLabel } = useFormattedDate();

  const isOverdue = isTicketOverdue({ dueDate, status });

  const handleSubmit = (state: TaskDueDateState | null) => {
    const newDueDate = state ? state.date : null;

    if (JSON.stringify(newDueDate) === JSON.stringify(dueDate)) {
      return;
    }

    onChange(newDueDate);
  };

  const Icon = isOverdue ? CalendarDueIcon : CalendarIcon;

  return (
    <TaskDueDateFormPopover
      placement="bottom"
      className="w-[375px]"
      renderTrigger={({ Trigger, triggerRef, isOpen }) => (
        <Trigger
          as={TicketDetailItem}
          ref={triggerRef}
          isInteractive
          isActive={isOpen}
          label="Due to"
          content={
            dueDate ? (
              <TicketPropertyPill
                icon={<Icon className="shrink-0" />}
                label={formatDateTimeLabel(dueDate, "concise")}
                className={cx(isOverdue && "border-tertiary-300")}
              />
            ) : (
              <TicketDetailItemPlaceholder />
            )
          }
        />
      )}
      initialState={dueDate ? { date: dueDate } : null}
      onSubmit={handleSubmit}
    />
  );
};
